import * as Home from '../constants/Home';

const initialState = {
  communities: [],
  loaded: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case Home.GET_COMMUNITIES_RESULT:
      return Object.assign({}, state, {
        communities: action.communities
      });

    case Home.COMMUNITY_LOAD_START:
      return Object.assign({}, state, {
        loaded: false
      });

    case Home.COMMUNITY_LOAD_END:
      return Object.assign({}, state, {
        loaded: true
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/Home.js